import { Component, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, filter, lastValueFrom, map, ReplaySubject, tap } from 'rxjs';
import { EventService } from '../../../services/event.service';
import { ZoomMtg } from '@zoom/meetingsdk';
import { StatisticsService } from 'src/app/services/statistics.service';
import { genUuid } from 'src/app/utils/uuid';
import { ViewManagerService } from 'src/app/services/views/view-manager.service';
import { publicSiteVisitTracker, SiteVisitTracker } from 'src/app/models/views/sitevisit-tracker';
import { ViewTrackerType } from 'src/app/models/payloads/view-payloads';
import { cookie_domain, web_url } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { DateTime } from 'luxon';
import { SiteVisitCookieService } from 'src/app/services/views/site-visit-cookie.service';
import { ZoomStatusService } from 'src/app/services/zoom-status.service';

@Component({
  selector: 'app-liveevent',
  templateUrl: './liveevent.component.html',
  styleUrl: './liveevent.component.scss'
})
export class LiveeventComponent {

  pingIntervalId: any;
  authEndpoint = 'http://localhost:3000/getSignature'
  // sdkKey = 'RqXMmTy8RDOqsAqK0Y6U_A'
  // meetingNumber = '81260973801'
  // passWord = ''
  role = 0
  zakToken = ''
  userName = ''
  userEmail = ''
  eventData
  viewUid
  registrantToken = 'iFRKETHSv7vkcnShMIRy8Aqh0LzqRFVh9ynCYPmhrBY.DQkAAAATssjVBhZWb3ZHeWo0UlNoS3FyM0N5UUZYTE53AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
  leaveUrl = 'https://app.sicuentame.com'
  evento
  // ReplaySubject: si la vista se inicializa antes de la suscripción, la emisión no se pierde
  private viewInit$ = new ReplaySubject<void>(1);
  siteVisitTracker: publicSiteVisitTracker | null = null

  private readonly uuidCookieName = 'cuentame_site_visit_uuid';
  private readonly timestampCookieName = 'cuentame_site_visit_timestamp';

  // Tiempo máximo para que Zoom responda antes de mostrar la pantalla de error
  private readonly ZOOM_TIMEOUT_MS = 90000;
  private zoomTimeoutId: any = null;
  private zoomReady = false;
  private zoomUiObserver: MutationObserver | null = null;
  // 'connection': Zoom no respondió o falló; 'eventNotFound': falló la consulta del evento por slug
  zoomError: 'connection' | 'eventNotFound' | null = null

  constructor(private ngZone: NgZone, private route: ActivatedRoute, private eventService: EventService, private stats: StatisticsService, private viewManager: ViewManagerService,
     private siteVisitCookie: SiteVisitCookieService, private zoomStatus: ZoomStatusService){
    this.siteVisitTracker = viewManager.exposePublicTracker(ViewTrackerType.Site)
  }

  ngAfterViewInit(): void {
    // if (this.evento !== undefined) {
    //   this.cargarVista(this.evento);
    // }

    this.viewInit$.next();
  }

  async cargarVista(evento){
    await this.decodeToken()
    let responseEvent
    try {
      responseEvent = await lastValueFrom(this.eventService.getWebinarData(evento))
    } catch (error) {
      console.error(error)
      if (this.isUnauthorized(error)) return this.redirectToLogin(evento);
      this.setZoomError('eventNotFound')
      return;
    }
    // let responseAccess =  await lastValueFrom(this.eventService.getWebinarAccess(responseEvent.data.liveEventAttendeeId))
    let responseAccess
    try {
      responseAccess = await lastValueFrom(this.eventService.getWebinarAccessV2(responseEvent.data.idLiveEvent))
    } catch (error) {
      if (this.isUnauthorized(error)) return this.redirectToLogin(evento);
      // Cualquier otro error sigue al catch de cargarVista y muestra el popup de conexión
      throw error;
    }
    this.eventData = responseEvent.data
    const meetingSDKElement = document.getElementById('meetingSDKElement');
    if (!meetingSDKElement) {
      console.error('meetingSDKElement no encontrado');
      return;
    }

    this.viewUid = genUuid();
    document.getElementById('zmmtg-root')!.style.display = 'block !important'

    try {
      await this.sendStartedNew()
    } catch (error) {
      
    }
    
    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.i18n.load('es-ES');
      ZoomMtg.i18n.reload('es-ES');
      ZoomMtg.init({
        leaveUrl: this.leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: (success: any) => {
          console.log(success)
          // La vista previa y la sala de espera aparecen antes de que join resuelva (join espera el clic en "Unirse")
          ZoomMtg.inMeetingServiceListener('onPreviewPannel', () => this.setZoomReady());
          ZoomMtg.inMeetingServiceListener('onUserIsInWaitingRoom', () => this.setZoomReady());
          ZoomMtg.inMeetingServiceListener('onJoinSpeed', (data: any) => {
            // Etiquetas >= 2: vista previa, esperando al anfitrión, sala de espera o ya dentro de la reunión
            const tag = data?.level ?? data?.tag
            if (typeof tag === 'number' && tag >= 2) this.setZoomReady()
          });
          this.watchZoomUi()
          ZoomMtg.join({
            signature: responseAccess.data.signature,
            meetingNumber: responseAccess.data.zoomMeetingId,
            passWord: '',
            userName: this.userName,
            userEmail: this.userEmail,
            tk: responseAccess.data.zoomRegistrantToken,
            // zak: this.zakToken,
            success: async (success: any) => {
              this.setZoomReady()
              ZoomMtg.inMeetingServiceListener('onMeetingStatus', (data: any) => {
                const estado = data.meetingStatus;
                if (estado === 3 || estado === 4) {
                  console.log('La reunión ha terminado o se está cerrando');
                  this.sendFinishPing();
                  this.stopCurrentPing();
                  // Redirige o actualiza tu UI aquí
                }
              });
              try {
                await this.sendStartedPing()
              } catch (error) {
                console.error('[Analytics] liveEventViewStart falló', error)
              }
              this.startCurrentPing()
              console.log('INICIO', success)
            },
            error: (error: any) => {
              console.log(error)
              this.setZoomError()
            }
          })
        },
        error: (error: any) => {
          console.log(error)
          this.setZoomError()
        }
      })
    })
  }

  private startZoomTimeout(): void {
    this.zoomTimeoutId = setTimeout(() => this.setZoomError(), this.ZOOM_TIMEOUT_MS)
  }

  private clearZoomTimeout(): void {
    if (!this.zoomTimeoutId) return;
    clearTimeout(this.zoomTimeoutId)
    this.zoomTimeoutId = null
  }

  // Respaldo por si el SDK no emite los eventos: detecta en el DOM el botón "Unirse" de la vista previa
  private watchZoomUi(): void {
    const zoomUiRendered = () => !!document.querySelector('#zmmtg-root .preview-join-button')
    if (zoomUiRendered()) return this.setZoomReady();

    this.zoomUiObserver = new MutationObserver(() => {
      if (zoomUiRendered()) this.setZoomReady()
    })
    this.zoomUiObserver.observe(document.body, { childList: true, subtree: true })
  }

  private stopWatchingZoomUi(): void {
    this.zoomUiObserver?.disconnect()
    this.zoomUiObserver = null
  }

  private setZoomReady(): void {
    if (this.zoomReady) return;
    this.zoomReady = true
    this.clearZoomTimeout()
    this.stopWatchingZoomUi()
    // Los callbacks de Zoom corren fuera de la zona de Angular.
    // Si ya se mostraba el error porque Zoom tardó, se quita para dejar entrar al usuario
    this.ngZone.run(() => {
      this.zoomError = null
      this.zoomStatus.setStatus('ready')
    })
  }

  private setZoomError(type: 'connection' | 'eventNotFound' = 'connection'): void {
    // Si Zoom ya respondió, un error posterior lo maneja la propia interfaz de Zoom
    if (this.zoomReady) return;
    this.clearZoomTimeout()
    this.ngZone.run(() => {
      this.zoomError = type
      this.zoomStatus.setStatus('error')
    })
  }

  retry(): void {
    window.location.reload()
  }

  private isUnauthorized(error: any): boolean {
    return error instanceof HttpErrorResponse && error.status === 401
  }

  // Sesión vencida o inválida: misma redirección que LoggedInGuard
  private redirectToLogin(evento: string): void {
    this.clearZoomTimeout()
    document.location.href = `${web_url}?eventoUrl=${evento}`;
  }

  ngOnInit(): void {
    // this.route.queryParams.subscribe(params => {
    //   this.evento = params['evento'];
    //   console.log(this.evento);
    // });

    // Cubre también fallos antes de Zoom (API, token, falta de slug): si en ZOOM_TIMEOUT_MS no hay respuesta se muestra el error
    this.startZoomTimeout()

    const evento$ = this.route.queryParamMap.pipe(
      map(params => params.get('slug')),
      tap(evento => {
        console.log('[LiveEvent] slug del queryParam:', evento)
        // Sin slug no hay evento que cargar; antes se quedaba esperando hasta el timeout
        // (se difiere para no cambiar el spinner de AppComponent en medio de su detección de cambios)
        if (!evento) queueMicrotask(() => this.setZoomError('eventNotFound'))
      }),
      filter(evento => !!evento)
    );

    combineLatest([evento$, this.viewInit$])
      .subscribe(([evento]) => {
        this.cargarVista(evento as string).catch(error => {
          console.error(error)
          this.setZoomError()
        });
    });


  }

  async decodeToken() {
    const cookie = document.cookie.match(new RegExp('(^| )' + 'cuentame_token' + '=([^;]+)'));
    // const token = localStorage.getItem('id_token');
    // console.log(token)
    const token = cookie ? cookie[2] : null;
    console.log(token)

    const payload = token!.split('.')[1]; // segunda parte del JWT
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/')); // decodifica Base64
    const data = JSON.parse(decoded)
    this.userName = data.firstName;
    this.userEmail = data.email;
    // return JSON.parse(decoded); // convierte a objeto
  }

  async sendStartedPing(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewStart',
      properties: { 
        liveEventViewUuid: this.viewUid,
      }
    }))
  }

  async sendStartedNew(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewNew',
      properties: { 
        liveEventViewUuid: this.viewUid,
        siteVisitUuid: this.stats.siteVisitUuid,
        liveEventSessionId: this.eventData.nextSession.idLiveEventSession,
        liveEventId: this.eventData.nextSession.liveEventId,
      }
    }))
  }

  async sendFinishPing(){
    await lastValueFrom(this.stats.sendAnalyticsEvent({
      eventType: 'liveEventViewFinish',
      properties: { 
        liveEventViewUuid: this.viewUid,
      }
    }))
  }

  async startCurrentPing(){
    this.pingIntervalId = setInterval(async() => {
      try {
        await lastValueFrom(this.stats.sendAnalyticsEvent({
          eventType: 'liveEventViewPing',
          properties: {
            liveEventViewUuid: this.viewUid,
          }
        }))
      } catch (error) {
        console.error('[Analytics] liveEventViewPing falló', error)
      }
      await this.sendData()
    }, 20000);
  }

  stopCurrentPing(){
    if (this.pingIntervalId) {
      console.log('DESACTIVADO')
      clearInterval(this.pingIntervalId);
      this.pingIntervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearZoomTimeout()
    this.stopWatchingZoomUi()

    const zoomRoot = document.getElementById('zoom-root');
    if (zoomRoot) {
      zoomRoot.innerHTML = '';
      zoomRoot.removeAttribute('style'); // elimina estilos inline
    }

    // También puedes resetear el body si Zoom lo modificó
    document.body.style.backgroundColor = '';
  }

  sendData(){
    const siteVisitUuid = this.stats.siteVisitUuid;
    const siteVisitTimestamp = this.stats.timestamp;

    console.log('sitevisit', siteVisitUuid)
    console.log('sitevisit', siteVisitTimestamp)
    if (!siteVisitUuid || !siteVisitTimestamp) return;

    this.siteVisitCookie.setSiteVisit(siteVisitUuid, siteVisitTimestamp);
  }
}
